var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('s-crud',{attrs:{"title":"Listado de Pallets a desinfectadas","config":_vm.config,"filter":_vm.filter,"height":"auto","group-by":'SplName'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }